export const fetchUsersFiltersUrl = `/users/list/filters`;
export const fetchUsersCreateUrl = `/users`;
export const fetchUsersListUrl = `/users`;
export const fetchUsersInfoUrl = `/users`;
export const fetchUsersCancelUrl = `/users`;
export const fetchUsersBlockUrl = `/users`;
export const fetchUsersUpdateUrl = `/users`;
export const fetchUsersUpdatePasswordWithoutOldUrl = `/users`;
export const fetchUsersRoutesUrl = `/users`;
export const fetchUsersAddRoutesUrl = `/users`;
